//AUTH
export const LOGINSUCCESS = "LOGINSUCCESS";
export const LOGINFAILED = "LOGINFAILED";


// WEBPACK FOOTER //
// ./src/Store/actionTypes.js